export default __webpack_public_path__ + "static/1-01bee4d24c8c197da84a1311218670ff.jpg";